import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { getSubscriptionStatus } from 'repository/subscriptionRepository';

const RequireSubscription = ({ children }) => {
    const [cookies] = useCookies(['access']);
    const [loading, setLoading] = React.useState(true);
    const [isPaid, setIsPaid] = React.useState(false);

    React.useEffect(() => {
        const token = cookies.access;

        if (!token) {
            setLoading(false);
            return;
        }

        getSubscriptionStatus(token, (error, data) => {
            if (!error && data?.paid) {
                setIsPaid(true);
            }
            setLoading(false);
        });
    }, []);

    if (loading) return <div>Checking subscription...</div>;

    if (!isPaid) {
        return <Navigate to="/subscription" replace />;
    }

    return children;
};

export default RequireSubscription;
